import {createFileRoute, useParams} from "@tanstack/react-router";

import {config} from "@/config/config.ts";
import ClubLandingPage from "../clubs/ClubLandingPage.tsx";
import {clubPagePath} from "../clubs/clubUrl.ts";
import services from "../services";

/**
 * Public club landing page under a prefix: scorepal.co/club/{club-slug}.
 *
 * The CANONICAL home of every club — venue, team and community alike; see `clubs/clubUrl.ts`.
 * The old root form (scorepal.co/{slug}) 301s here.
 */
export const Route = createFileRoute("/club/$club_slug")({
    component: RouteComponent,
    loader: async ({params}) => {
        try {
            const data = await services.clubs.page(params.club_slug);
            return {club: data?.club ?? null};
        } catch {
            return {club: null};
        }
    },
    head: ({loaderData, params}) => {
        const club: any = (loaderData as any)?.club;
        const name = club?.name || params.club_slug;
        const location = [club?.city, club?.country_code].filter(Boolean).join(", ");
        const desc = `${name}${location ? ` in ${location}` : ""} on ScorePal — open events, live scores, draws, standings and past champions.`;
        return {
            meta: [
                {title: `${name} | ScorePal`},
                {name: "description", content: desc},
                {property: "og:title", content: `${name} | ScorePal`},
                {property: "og:description", content: desc},
                ...(club?.image_url ? [{property: "og:image", content: club.image_url}] : []),
            ],
            links: [{rel: "canonical", href: config.publicUrl + clubPagePath(params.club_slug, club?.type)}],
        };
    },
});

function RouteComponent() {
    const {club_slug} = useParams({from: "/club/$club_slug"});
    return <ClubLandingPage slug={club_slug} />;
}
